export default __webpack_public_path__ + "static/media/Sage's Boots of the Soaring God.84480d39.jpg";